const SCOPE_SELECTOR = [
  'header',
  'header-menu',
  'header-drawer',
  'footer',
  '[class^="cms-"]',
  '[class*=" cms-"]',
].join(',');

const LINK_SELECTOR = 'a[href]';

function isExternalHttpLink(href) {
  const raw = String(href || '').trim();
  if (!raw) return false;

  // Keep internal/special links untouched.
  if (
    raw.startsWith('#') ||
    raw.startsWith('/') ||
    raw.startsWith('?') ||
    raw.startsWith('mailto:') ||
    raw.startsWith('tel:') ||
    raw.startsWith('sms:') ||
    raw.startsWith('javascript:') ||
    raw.startsWith('data:')
  ) {
    return false;
  }

  try {
    const url = new URL(raw, window.location.href);
    const isHttp = url.protocol === 'http:' || url.protocol === 'https:';
    return isHttp && url.origin !== window.location.origin;
  } catch {
    return false;
  }
}

function ensureRelSecurity(link) {
  const relTokens = new Set(
    String(link.getAttribute('rel') || '')
      .split(/\s+/)
      .map((token) => token.trim())
      .filter(Boolean)
  );
  relTokens.add('noopener');
  relTokens.add('noreferrer');
  link.setAttribute('rel', Array.from(relTokens).join(' '));
}

function processLink(link) {
  if (!link.closest(SCOPE_SELECTOR)) return;
  if (!isExternalHttpLink(link.getAttribute('href'))) return;
  link.setAttribute('target', '_blank');
  ensureRelSecurity(link);
}

function processExternalLinks(root = document) {
  if (root instanceof Element && root.matches(LINK_SELECTOR)) {
    processLink(root);
  }
  const links = root.querySelectorAll(LINK_SELECTOR);
  links.forEach(processLink);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    processExternalLinks(document);
  });
} else {
  processExternalLinks(document);
}
